@let workspaces =
  assistantGroup.workspace.plugins.currentListPlugin.feature.selectors.entities.asSignal();
@let creationWorkspace =
  assistantGroup.workspace.plugins.currentEntityPlugin.feature.selectors
    .getCreationEntity()
    .asSignal();
@let isSubmitting =
  assistantGroup.workspace.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<div class="workspace-tree">
  <!-- Workspaces Section -->
  <div class="workspace-tree__section">
    @for (workspace of workspaces; track workspace.id) {
      <atn-workspace-item [workspace]="workspace" />
    } @empty {
      <div class="workspace-tree__global-empty">
        <span>No workspaces</span>
      </div>
    }
  </div>

  @let globalConversations = assistantGroup.globalConversationGroup.asSignal();

  <!-- Global Conversations Section -->
  @let isGlobalExpanded = isGlobalExpandedSg();
  <div class="workspace-tree__global">
    <div
      class="workspace-tree__global-header"
      (click)="isGlobalExpandedSg.set(!isGlobalExpanded)"
    >
      <i
        class="atn-icon workspace-tree__chevron atn-blue"
        [class.atn-angle-down]="isGlobalExpanded"
        [class.atn-angle-right]="!isGlobalExpanded"
      ></i>
      <span class="workspace-tree__global-title">{{
        globalConversations?.name ?? 'Global Conversations'
      }}</span>
    </div>

    @if (isGlobalExpanded) {
      <div class="workspace-tree__global-list">
        @for (
          conversation of globalConversations?.entities ?? [];
          track conversation.id
        ) {
          <atn-conversation-item [conversation]="conversation" />
        } @empty {
          <div class="workspace-tree__global-empty">
            <span>No conversations</span>
          </div>
        }
      </div>
    }
  </div>
</div>

@if (creationWorkspace) {
  <atn-ds-centered-overlay>
    <atn-ds-widget title="Create Workspace">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelCreateWorkspace()"
      ></i>
      <div class="workspace-tree__create-dialog-content">
        <atn-ds-text
          label="Name"
          placeholder="Enter workspace name"
          [value]="creationWorkspace.name"
          (change)="updateWorkspace({ name: $event ?? '' })"
        ></atn-ds-text>
        <atn-ds-text
          label="Description"
          placeholder="Enter workspace description"
          [value]="creationWorkspace.description ?? ''"
          (change)="updateWorkspace({ description: $event ?? '' })"
        ></atn-ds-text>
        <atn-ds-select-multiple
          label="Shared with"
          [items]="store.userItems()"
          [config]="{ overlay: { hasSearch: true } }"
          [value]="creationWorkspace.sharedWith ?? []"
          (valueChange)="updateWorkspace({ sharedWith: $any($event) })"
        />
        <atn-ds-notice
          [style]="StyleEnum.Warning"
          description="Sharing a workspace will also share all conversations within it."
        />
      </div>
      <div
        footer
        class="workspace-tree__create-dialog-footer"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelCreateWorkspace()"
          [disabled]="isSubmitting"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveWorkspace()"
          [loading]="isSubmitting"
          >Create</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
